import { render } from "./page-schools.vue?vue&type=template&id=05381b83"
import script from "./page-schools.js?vue&type=script&lang=js"
export * from "./page-schools.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__